export const environment = {
  production: false,
  //staging
  //Login_URL:'http://telemedicinephcapi.esdinfra.com/'

  //stagingpvt
  //Login_URL: 'https://telemedicinepvtapi.esdinfra.com/'

  //local
  //Login_URL: 'http://localhost:32973/'

  //Live
  // Login_URL:'https://telmed.medetel.in/'  

  //Demo
  // Login_URL:'https://demo.pvtapi.esdinfra.com/'

  //Private hostpital
  Login_URL:'https://hospapi.esdinfra.com/'  


};
